import React, { useState, useEffect } from "react";
import { Container, Row, Col } from "react-bootstrap";
import {
  BarChart4,
  Trophy,
  LocateFixed,
  Settings,
  FileText,
  ShieldCheck,
} from "lucide-react";

import "../buidl.css";

function Development() {
  const [isSmallScreen, setIsSmallScreen] = useState(window.innerWidth <= 768);

  useEffect(() => {
    const handleResize = () => {
      setIsSmallScreen(window.innerWidth <= 768);
    };

    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

//   const handleContextMenu = (e) => {
//     e.preventDefault(); // Disable right-click
//   };

  const headingStyle = {
    fontSize: "48px",
    fontWeight: "bold",
    marginBottom: "20px",
  };

  const subheadingStyle = {
    fontSize: "0.85rem",
    color: "#555",
    marginBottom: "10px",
    marginTop: "20px",
  };

  const iconContainerBase = {
    fontSize: "30px",
    marginBottom: "10px",
    width: "40px",
    height: "40px",
    borderRadius: "50%",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  };

  const titleStyle = {
    fontWeight: "bold",
    fontSize: "16px",
    marginBottom: "10px",
  };

  const descStyle = {
    fontSize: "0.81rem",
    color: "#333",
  };

  const data = [
    {
      icon: <BarChart4 color="#4f46e5" size={20} />,
      bg: "#e0e7ff",
      title: "MARKET ANALYSIS",
      desc: "Buidl taps into the growing demand for decentralized, AI-driven project collaboration tools in the freelance and startup economy.",
    },
    {
      icon: <Trophy color="#d97706" size={20} />,
      bg: "#fef3c7",
      title: "COMPETITOR ANALYSIS",
      desc: "Buidl competes with platforms like Upwork, Toptal, and Braintrust by offering AI-powered talent matching, crypto/fiat payments, and integrated project management tools.",
    },
    {
      icon: <LocateFixed color="#059669" size={20} />,
      bg: "#d1fae5",
      title: "USER BEHAVIOR TRENDS",
      desc: "On Buidl, users seek personalized project matches, secure transactions, and seamless collaboration.",
    },
    {
      icon: <Settings color="#7c3aed" size={20} />,
      bg: "#ede9fe",
      title: "TECHNOLOGY TRENDS",
      desc: "AI—autonomous systems capable of proactive decision-making—and the expansion of edge computing, which brings data processing closer to users for faster",
    },
    {
      icon: <FileText color="#2563eb" size={20} />,
      bg: "#dbeafe",
      title: "CONTENT STRATEGY",
      desc: "Buidls content strategy focuses on educating and engaging its core audiences—founders, freelancers, and project managers",
    },
    {
      icon: <ShieldCheck color="#F87171" size={20} />,
      bg: "#FFD5D5",
      title: "USABILITY STANDARDS",
      desc: "Buidl adheres to usability standards that prioritize intuitive navigation, accessible interfaces, and responsive design across devices.",
    },
  ];

  return (
    <Container
      fluid
      className="container-section"
      style={{
        backgroundColor: "#FFFFFF",
        paddingTop: isSmallScreen ? "2rem" : "5rem",
         paddingBottom: isSmallScreen ? "2rem" : "5rem",
          display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        height: isSmallScreen ? "auto" : "100vh",
      }}
    >
      <Row style={{ marginBottom: isSmallScreen ? "0rem" : "1rem" }}>
        <Col xs={12} md={6} lg={6} style={headingStyle}>
          Development process
        </Col>
        <Col xs={12} md={6} lg={6} style={subheadingStyle}>
          The development process for Buidl follows a user-centered, agile
          approach—starting with wireframes, followed by iterative design,
          prototyping, and testing
        </Col>

         <hr />
      </Row>
      
      <Row>
        {data.map((item, index) => (
          <Col md={4} key={index} style={{ marginBottom: "30px" }}>
            <div style={{ ...iconContainerBase, backgroundColor: item.bg }}>
              {item.icon}
            </div>
            <div style={titleStyle}>{item.title}</div>
            <div style={descStyle}>{item.desc}</div>
          </Col>
        ))}
      </Row>
    </Container>
  );
}

export default Development;